<template>
  <div>
    <h1>{{ $t("delegationOrder.orderList.title") }}</h1>
    <delegation-menu></delegation-menu>
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <v-btn block color="accent" to="/new-trip" v-if="hasPermissionForNewDelegationOrder">{{ $t("delegationOrder.orderList.newBusinessTrip") }}</v-btn>
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="delegationOrders" :search="search" :loading="$store.getters['Ajax/loading'] ? 'accent' : false">
      <template #item="props">
        <tr>
          <td class="text-left">
            <document-number :number="props.item.number" :temp-number="props.item.custom_number" />
          </td>
          <td class="text-left">
            {{ !!props.item.delegated_user ? props.item.delegated_user : $t("global.notSet") }}
          </td>
          <td class="text-left">
            {{ !!props.item.date_start ? props.item.date_start : $t("global.notSet") }}
          </td>
          <td class="text-left">
            {{ !!props.item.date_end ? props.item.date_end : $t("global.notSet") }}
          </td>
          <td class="text-center">
            <delegation-order-status-chip :status="props.item.status"></delegation-order-status-chip>
          </td>
          <td class="text-center">
            <action-list :action-list="props.item.actions" :context-item-id="props.item.id"> </action-list>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ActionList from "../../components/Actions/ActionList.vue";
import DelegationMenu from "../../components/DelegationMenu.vue";
import DocumentNumber from "../../components/Shared/DocumentNumber.vue";
import DelegationOrderStatusChip from "../../components/DelegationOrder/DelegationOrderStatusChip";

export default {
  name: "DelegationOrderView",
  components: {
    DelegationOrderStatusChip,
    DocumentNumber,
    DelegationMenu,
    ActionList
  },
  data: () => ({
    search: "",
    vehicle: null
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t("delegationOrder.delegationOrderNumber"),
          value: "number"
        },
        { text: this.$t("delegation.delegated"), value: "delegated_user" },
        { text: this.$t("delegation.startDate"), value: "date_start" },
        { text: this.$t("delegation.endDate"), value: "date_end" },
        { text: this.$t("delegation.status"), value: "status", align: "center" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    },
    delegationOrders: function() {
      return this.$store.getters["DelegationOrder/delegationOrderList"];
    },
    hasPermissionForNewDelegationOrder() {
      return (
        this.$store.getters.hasPermission("createDelegationOrderAll") ||
        this.$store.getters.hasPermission("createDelegationOrderSelf") ||
        this.$store.getters.hasPermission("SuperAdmin") ||
        this.$store.getters.hasPermission("companyAdmin")
      );
    }
  },
  methods: {
    isTempNumber(item) {
      return !item.number && !!item.custom_number;
    }
  },
  created() {
    this.$store.dispatch("DelegationOrder/loadAllDelegationOrders");
  }
};
</script>

<style scoped></style>
